import { ImageFlowCapturingDataType } from '@/common/components/camera/types/Camera.type';
import { VehicleTypesType } from '@/common/types/Files.type';
import { MutableRefObject } from 'react';

export enum SliderEnum {
  DAMAGED_PARTS = 'damaged_parts',
  VEHICLE = 'vehicle',
  EXTRA_IMAGES = 'extraImages',
}
export type CustomMediaPropsType = {
  photoRef: MutableRefObject<HTMLCanvasElement | null>;
  videoRef: MutableRefObject<HTMLVideoElement | null>;
  rotate?: boolean;
  cameraShot?: boolean;
};

export type ImageSliderPropsType = {
  turn: number;
  sliderData: ImageFlowCapturingDataType;
  isVehicle: boolean;
  vehicleType: VehicleTypesType;
};
